import UltMeta, { Meta } from "./UltMeta/index";

class BusinessStatus extends UltMeta {
    NOT_STARTED = new Meta(0, "未开始");
    IN_PROGRESS = new Meta(1, "进行中");
    COMPLETED = new Meta(2, "已完成");
    INVALID = new Meta(3, "作废中");
}

export const BUSINESS_STATUS = new BusinessStatus();
